import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/tick-circle.svg';
import { Icon } from '../Icon/Icon';
export const TickCircleIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
